import styled from '@emotion/styled';

import { useUserContext } from '../../../contexts/UserContext';
import { Header, Text, Anchor, TextButton, Spacer } from '../../atoms';
import { CheckField, TextField } from '../../molecules';
import useForm from '../../../hooks/useForm';
import theme from '../../../styles/theme';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 68px 130px;
  box-shadow: ${theme.surface.boxShadow};
  border-radius: ${theme.surface.borderRadius};

  ${theme.mediaQuery('tablet')} {
    padding: 0;
    box-shadow: none;
  }
`;

const TextFieldsContainer = styled.div`
  width: 100%;
  margin-top: ${theme.spacing.xxl};
`;

const LogInForm = () => {
  const { handleLogIn } = useUserContext();

  const { errors, isLoading, handleChange, handleSubmit } = useForm({
    initialValue: {
      email: '',
      password: '',
      stayLoggedIn: false,
    },
    onSubmit: async (values) => {
      await handleLogIn({
        email: values.email,
        password: values.password,
      });
    },
    validate: ({ email, password }) => {
      const errors = {};

      if (!email) {
        errors.email = '아이디를 입력해주세요.';
      } else if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/.test(email)) {
        errors.email = '올바른 이메일을 입력해주세요.';
      }
      if (!password) {
        errors.password = '비밀번호를 입력해주세요.';
      }

      return errors;
    },
  });

  return (
    <Form onSubmit={handleSubmit}>
      <Header style={{ marginBottom: theme.spacing.l }}>로그인</Header>
      <div style={{ display: 'flex' }}>
        <Text size="sm">아직 가입되어 있지 않나요?&nbsp;&nbsp;</Text>
        <Anchor underline size="sm" to="/signup">
          회원가입
        </Anchor>
      </div>
      <TextFieldsContainer>
        <Spacer size={theme.spacing.s} align="vertical">
          <TextField
            isFullWidth
            name="email"
            placeholder="이메일을 입력해주세요"
            label="이메일"
            iconName="at-sign"
            onChange={handleChange}
            error={!!errors.email}
          />
          {errors.email ? (
            <Text
              size="xs"
              color={theme.colors.error}
              style={{ textAlign: 'right', marginTop: `-${theme.spacing.xs}` }}
            >
              {errors.email}
            </Text>
          ) : null}
          <TextField
            isFullWidth
            name="password"
            placeholder="비밀번호를 입력해주세요"
            label="비밀번호"
            iconName="lock"
            onChange={handleChange}
            error={!!errors.password}
            type="password"
          />
          {errors.password ? (
            <Text
              size="xs"
              color={theme.colors.error}
              style={{ textAlign: 'right', marginTop: `-${theme.spacing.xs}` }}
            >
              {errors.password}
            </Text>
          ) : null}
          <CheckField
            label="자동 로그인"
            name="stayLoggedIn"
            onChange={handleChange}
          />
        </Spacer>
        {errors.badRequest ? (
          <Text
            color={theme.colors.error}
            style={{ marginTop: theme.spacing.m }}
          >
            아이디와 비밀번호가 일치하지 않습니다.
          </Text>
        ) : null}
      </TextFieldsContainer>
      <TextButton
        type="submit"
        size="100%"
        disabled={isLoading}
        style={{ marginTop: theme.spacing.l }}
      >
        로그인
      </TextButton>
    </Form>
  );
};

export default LogInForm;
